import React from 'react';
import Navbar from "./components/Navbar";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.bundle.js";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Home from "./components/Home";
import Login from "./components/Login";
import "./styles/navbar.css";
import Signup from "./components/Signup";
import Mycart from './components/Mycart';
import Contact from './components/Contact';
import Appprovider from './components/Reducercontext';
import Myorders from './components/Myorders';

function App() {
  const isLoggedIn = !!localStorage.getItem("authtoken");
  const location = useLocation();

  // Hide Navbar on login/register pages (optional)
  const hideNavbar = location.pathname === "/login" || location.pathname === "/register";

  return (
    <Appprovider>
      {!hideNavbar && <Navbar />}

      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Signup />} />

        {/* Protected routes - require login */}
        <Route path="/" element={isLoggedIn ? <Home /> : <Navigate to="/login" />} />
        <Route path="/mycart" element={isLoggedIn ? <Mycart /> : <Navigate to="/login" />} />
        <Route path="/contact" element={isLoggedIn ? <Contact /> : <Navigate to="/login" />} />
        <Route path="/myorders" element={isLoggedIn ? <Myorders /> : <Navigate to="/login" />} />
      </Routes>
    </Appprovider>
  );
}

export default App;
